import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useCases } from '@/hooks';
import { pendingCases } from '../filterCases';
import { CaseList } from '../components/CaseList';

const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  a {
    color: ${({ theme }) => theme.color.accentCyan};
    text-decoration: none;
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
  a:hover {
    text-decoration: underline;
  }
`;
const Note = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

export function HumanReviewSection() {
  const { cases } = useCases();
  return (
    <div>
      <Bar>
        <Note>Cases a rotating team is actively reviewing.</Note>
        <Link to="/council/voting-board">Vote on the board →</Link>
      </Bar>
      <CaseList cases={pendingCases(cases)} emptyLabel="No cases awaiting human review." />
    </div>
  );
}
